<template>
  <router-view></router-view>
</template>

<script setup>

</script>

<style lang="scss" rel="stylesheet/scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
